import React, { useRef } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./PromoSlider.module.css";

/* ---------- Top-left badge icons ---------- */
/* Outline Deseyne® droplet brand mark with inner swirl */
const DropIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#00A7E1" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 2.6c3.5 4.5 5.9 7.6 5.9 10.8A5.9 5.9 0 1 1 6.1 13.4C6.1 10.2 8.5 7.1 12 2.6Z" />
    <path d="M14.4 13.1a2.7 2.7 0 1 1-2.6-3.4" />
    <path d="M14.4 9.1v5.6" />
  </svg>
);

/* ---------- Top-right dotted grid decoration ---------- */


const AwardIcon = () => (
  <svg width="79" height="88" viewBox="0 0 79 88" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M39.037 0.5C30.4089 0.506787 22.1361 3.93767 16.0356 10.0392C9.935 16.1407 6.50543 24.414 6.5 33.0421C6.50407 41.6702 9.93338 49.9438 16.0344 56.0448C22.1354 62.1458 30.4089 65.5751 39.037 65.5792C47.6651 65.5751 55.9387 62.1458 62.0397 56.0448C68.1407 49.9438 71.57 41.6702 71.574 33.0421C71.5686 24.4131 68.1383 16.139 62.0367 10.0374C55.935 3.93571 47.6609 0.50543 39.0319 0.5H39.037ZM39.037 3.21056C42.9544 3.20922 46.8337 3.97999 50.4531 5.47881C54.0725 6.97764 57.3609 9.17513 60.1305 11.9456C62.9001 14.7162 65.0964 18.0054 66.594 21.6253C68.0916 25.2452 68.861 29.1247 68.8583 33.0421C68.8583 49.531 55.5259 62.8635 39.037 62.8635C22.5482 62.8635 9.21569 49.531 9.21569 33.0421C9.21299 29.1251 9.98226 25.246 11.4795 21.6265C12.9768 18.0069 15.1727 14.7179 17.9417 11.9475C20.7107 9.17701 23.9986 6.97941 27.6174 5.48029C31.2362 3.98116 35.1149 3.20989 39.0319 3.21056H39.037Z" fill="#00A7E1" stroke="#00A7E1"/>
<path d="M13.4075 51.6777L0.674514 73.726C0.547277 73.9521 0.487475 74.2099 0.502185 74.469C0.516894 74.728 0.6055 74.9774 0.757515 75.1876C0.909531 75.3978 1.11859 75.5601 1.35996 75.6553C1.60132 75.7504 1.86489 75.7744 2.11946 75.7244L15.0882 73.1624L19.3513 85.6853C19.4357 85.9318 19.5892 86.1487 19.7935 86.3104C19.9978 86.472 20.2443 86.5714 20.5036 86.5968C20.7628 86.6222 21.0239 86.5725 21.2557 86.4535C21.4875 86.3346 21.6802 86.1516 21.8108 85.9261L34.2876 64.3236L31.9357 62.9607L20.9551 81.9705L17.2761 71.159C17.1696 70.8494 16.955 70.5887 16.6716 70.4249C16.3882 70.2611 16.0551 70.2051 15.7338 70.2674L4.52259 72.4758L15.7543 53.0356L13.4075 51.6777ZM64.6674 51.6777L62.3258 53.0407L73.5523 72.4809L62.3462 70.2725C62.0249 70.2103 61.6918 70.2662 61.4084 70.43C61.1251 70.5938 60.9104 70.8545 60.8039 71.1641L57.1198 81.9756L46.1444 62.9658L43.7873 64.3287L56.259 85.9261C56.3896 86.1516 56.5823 86.3346 56.8141 86.4535C57.0459 86.5725 57.3069 86.6222 57.5662 86.5968C57.8255 86.5714 58.072 86.472 58.2763 86.3104C58.4806 86.1487 58.6341 85.9318 58.7185 85.6853L62.9867 73.1624L75.9503 75.7244C76.2049 75.7744 76.4685 75.7504 76.7098 75.6553C76.9512 75.5601 77.1602 75.3978 77.3123 75.1876C77.4643 74.9774 77.5529 74.728 77.5676 74.469C77.5823 74.2099 77.5225 73.9521 77.3953 73.726L64.6674 51.6777Z" fill="#00A7E1" stroke="#00A7E1"/>
<path d="M39.0378 17.9414C38.0745 17.9414 37.9105 18.3616 37.6543 18.6229C36.1735 20.3343 34.1803 23.8596 33.4424 25.0278C30.9522 25.6478 28.3031 26.1653 26.0588 27.0466C25.7309 27.2106 25.2851 27.2465 24.9828 28.1585C24.6908 29.0757 25.0289 29.3575 25.198 29.6804C26.2894 31.5096 29.3945 34.9478 29.9889 35.6651C29.8352 38.3962 29.4611 40.8557 29.6302 43.31C29.6815 43.6687 29.5739 44.1042 30.3476 44.673C31.1264 45.2366 31.5107 45.0009 31.8694 44.9394C34.0061 44.427 37.8388 42.7157 39.0378 42.2391C41.446 43.1563 43.8338 44.3297 46.2011 44.9394C46.5597 45.0009 46.944 45.2366 47.7229 44.673C48.5017 44.1094 48.389 43.6687 48.4402 43.31C48.6247 41.1938 48.1482 36.5977 48.0815 35.6651C49.465 34.0459 50.9509 32.3089 52.2575 30.6437C53.0005 29.8341 53.3028 28.9732 53.0876 28.1585C52.8673 27.3438 52.3447 27.2106 52.0167 27.0466C49.6238 26.0987 47.0875 25.6478 44.6331 25.0278C43.2189 22.8758 41.9789 20.5085 40.4161 18.6229C40.1599 18.3667 40.0011 17.9414 39.0327 17.9414H39.0378ZM39.0378 21.2361C40.2265 22.9731 41.2257 24.7409 42.3581 26.4676C42.5426 26.7238 42.604 26.9032 43.0396 27.2209C43.4751 27.5334 43.6493 27.5334 43.9516 27.6308C45.9756 28.1688 47.9534 28.6094 49.9569 29.168C48.6862 30.8486 47.3027 32.3397 46.0115 33.9537C45.8219 34.2099 45.6784 34.3124 45.5093 34.8248C45.3454 35.3372 45.3966 35.5114 45.4017 35.824C45.5042 37.9248 45.6989 39.9436 45.7911 42.0239C43.5366 41.24 41.1386 39.9743 39.0378 39.5286C38.4998 39.5286 38.3563 39.6362 38.054 39.7335C36.0915 40.4816 34.2264 41.2912 32.2793 42.0188C32.3459 39.9077 32.5765 37.894 32.6739 35.824C32.6739 35.5114 32.7251 35.3321 32.5611 34.8248C32.3972 34.3124 32.2537 34.2099 32.059 33.9537C30.778 32.3346 29.2511 30.6129 28.1135 29.168C30.1375 28.5736 32.1256 28.1637 34.1239 27.6308C34.4262 27.5334 34.6005 27.5334 35.036 27.2209C35.4664 26.9032 35.533 26.7238 35.7123 26.4676C36.4297 25.4121 37.1266 24.2336 37.7363 23.2396C38.1493 22.5584 38.5833 21.8903 39.0378 21.2361Z" fill="#00A7E1" stroke="#00A7E1"/>
</svg>



);

const DocIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#00a7e1" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 3.5h6l4 4V19.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z" />
    <path d="M13 3.5V7.5h4" />
    <path d="M9 12h6M9 15h6M9 18h4" />
  </svg>
);

/* Clean line-art "clinical study" glyph (document + magnifier) that matches the
   thin blue outline style of the drop/award badges instead of the dense
   decorative ClinicalGraphic which turns into a solid blob at badge size. */
const ClinicalBadgeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#00a7e1" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.5 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5" />
    <path d="M8.5 8h6M8.5 11h6M8.5 14h3" />
    <circle cx="16" cy="16" r="3.2" />
    <path d="m18.4 18.4 2.4 2.4"
     />
  </svg>
);




const ClinicalGraphic = ({ className = styles.clinicalGraphic }) => (

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_843_14)">
<path d="M14.1259 3.09814L14.1556 3.0991C14.3042 3.10726 14.4449 3.17049 14.5503 3.27738C14.6626 3.39138 14.7255 3.54567 14.7255 3.70643V8.39636C8.9054 8.99974 8.73719 17.3536 14.5391 18.1791C14.5035 18.2144 14.4636 18.2452 14.42 18.2705C14.3306 18.3223 14.2293 18.3496 14.1263 18.3497H2.70085C2.54087 18.3496 2.38729 18.2854 2.2742 18.1712C2.16116 18.0571 2.09767 17.9024 2.09766 17.7411V3.70662C2.09774 3.54539 2.16123 3.39067 2.2742 3.27661C2.38014 3.16969 2.52154 3.10652 2.67051 3.09891L2.70047 3.09814H14.1259ZM3.88315 13.6674C3.75593 13.6675 3.63388 13.7184 3.54392 13.8092C3.45396 13.8999 3.40341 14.023 3.40341 14.1514C3.40341 14.2797 3.45396 14.4028 3.54392 14.4936C3.63388 14.5844 3.75592 14.6353 3.88315 14.6353H9.4122C9.53946 14.6353 9.66164 14.5844 9.75164 14.4936C9.84158 14.4028 9.89214 14.2797 9.89214 14.1514C9.89214 14.023 9.84158 13.8999 9.75164 13.8092C9.66164 13.7184 9.53946 13.6674 9.4122 13.6674H3.88315ZM3.88315 11.3825C3.75599 11.3826 3.63403 11.4336 3.54411 11.5243C3.45415 11.615 3.4036 11.7381 3.4036 11.8665C3.4036 11.9948 3.45416 12.118 3.54411 12.2087C3.63403 12.2994 3.756 12.3502 3.88315 12.3502H9.50037C9.62758 12.3502 9.74968 12.2994 9.83962 12.2087C9.92956 12.118 9.97993 11.9948 9.97995 11.8665C9.97995 11.7381 9.92956 11.615 9.83962 11.5243C9.74968 11.4335 9.62758 11.3825 9.50037 11.3825H3.88315ZM3.88315 9.09742C3.75599 9.09746 3.63403 9.14849 3.54411 9.23918C3.45415 9.32991 3.4036 9.45306 3.4036 9.58138C3.4036 9.70971 3.45416 9.83286 3.54411 9.92359C3.63403 10.0143 3.756 10.0651 3.88315 10.0652H9.96325C10.0904 10.0651 10.2124 10.0143 10.3023 9.92359C10.3923 9.83286 10.4428 9.70971 10.4428 9.58138C10.4428 9.45306 10.3923 9.32991 10.3023 9.23918C10.2124 9.14849 10.0904 9.09744 9.96325 9.09742H3.88315ZM16.9042 6.52559C17.0644 6.52555 17.223 6.55734 17.3709 6.61914C17.5189 6.68094 17.6534 6.77157 17.7666 6.88579C17.8798 6.99998 17.9695 7.13561 18.0308 7.2848C18.092 7.43404 18.1236 7.59405 18.1235 7.75555V9.41075C17.4176 8.85849 16.5741 8.51152 15.6852 8.40861V6.52559H16.9042ZM3.88315 6.81233C3.75599 6.81235 3.63403 6.86338 3.54411 6.95407C3.45415 7.04482 3.4036 7.16796 3.4036 7.29628C3.4036 7.4246 3.45416 7.54775 3.54411 7.6385C3.63403 7.72919 3.756 7.78002 3.88315 7.78004H12.9439C13.0711 7.78002 13.1931 7.72919 13.283 7.6385C13.3729 7.54775 13.4235 7.4246 13.4235 7.29628C13.4235 7.16796 13.373 7.04482 13.283 6.95407C13.1931 6.86338 13.0711 6.81235 12.9439 6.81233H3.88315ZM6.14839 4.41553C6.02121 4.41555 5.89929 4.46655 5.80935 4.55727C5.71942 4.64799 5.66886 4.77099 5.66884 4.89929C5.66884 5.02762 5.7194 5.15075 5.80935 5.2415C5.89929 5.33221 6.02123 5.38322 6.14839 5.38324H10.6787C10.8059 5.38322 10.9278 5.33221 11.0178 5.2415C11.1077 5.15075 11.1583 5.02762 11.1583 4.89929C11.1582 4.77099 11.1077 4.64799 11.0178 4.55727C10.9278 4.46655 10.8059 4.41555 10.6787 4.41553H6.14839Z" fill="url(#paint0_linear_843_14)" stroke="#00A7E1" stroke-width="0.7"/>
<path d="M11.9766 10.9445C14.2192 7.89771 19.0649 9.53628 19.0444 13.3055V13.3073C19.086 16.5056 15.3255 18.412 12.7912 16.478L12.7907 16.4774L12.7133 16.418C11.9222 15.7934 11.3974 14.8856 11.2496 13.8808C11.097 12.8435 11.3583 11.7874 11.9764 10.9443L11.9766 10.9445ZM15.1321 9.79241C14.5876 9.7901 14.0502 9.91763 13.5638 10.1646C13.0774 10.4117 12.6556 10.7712 12.3331 11.2138C12.2574 11.3171 12.2255 11.4466 12.2443 11.5736C12.2632 11.7007 12.3314 11.8148 12.4338 11.8912C12.5361 11.9675 12.6644 11.9997 12.7903 11.9807C12.9005 11.964 13.001 11.9093 13.0751 11.8267L13.1052 11.7896L13.1054 11.7894C13.3386 11.4687 13.6438 11.2081 13.9959 11.0292C14.348 10.8504 14.7371 10.7581 15.1314 10.7601H15.1319C15.2591 10.7601 15.3811 10.7091 15.471 10.6184C15.5609 10.5276 15.6115 10.4047 15.6115 10.2764C15.6115 10.148 15.5609 10.0249 15.471 9.93414C15.3811 9.84347 15.2592 9.79247 15.1321 9.79241Z" fill="url(#paint1_linear_843_14)" stroke="#00A7E1" stroke-width="0.7"/>
<path d="M18.1239 18.0396V20.5472C18.1239 20.7087 18.0924 20.8687 18.0312 21.0179C17.9699 21.1671 17.8802 21.3028 17.767 21.417C17.6538 21.5312 17.5192 21.6218 17.3713 21.6836C17.2233 21.7454 17.0647 21.7772 16.9046 21.7771H6.71518C6.55508 21.7771 6.39644 21.7452 6.24852 21.6834C6.10062 21.6216 5.96615 21.531 5.85297 21.4168C5.7398 21.3026 5.65006 21.1669 5.58881 21.0177C5.52759 20.8685 5.49605 20.7087 5.49609 20.5472V19.3174H14.1268C14.4737 19.3177 14.8106 19.2007 15.0837 18.985C15.3385 18.7836 15.5239 18.5071 15.6148 18.1949C16.2489 18.1329 16.8645 17.9457 17.4263 17.6435L17.5419 17.5792L18.1239 18.0396ZM21.3905 16.7373L21.3922 16.7387L21.4256 16.7639C21.7477 17.0193 21.8543 17.454 21.7675 17.8535C21.6782 18.265 21.3899 18.6134 20.955 18.6745C20.8285 18.6932 20.6988 18.6856 20.5754 18.6519C20.452 18.6183 20.3368 18.5594 20.2369 18.479L20.2361 18.4782L18.9353 17.4516L18.8784 17.4061L18.3545 16.9921C18.611 16.7637 18.8438 16.5093 19.0487 16.2325C19.259 15.9459 19.4373 15.6363 19.5804 15.3105L21.3905 16.7373Z" fill="url(#paint2_linear_843_14)" stroke="#00A7E1" stroke-width="0.7"/>
</g>
<defs>
<linearGradient id="paint0_linear_843_14" x1="10.1106" y1="3.00021" x2="10.1106" y2="18.4476" gradientUnits="userSpaceOnUse">
<stop stop-color="#EDF7FD"/>
<stop offset="0.503088" stop-color="white"/>
<stop offset="1" stop-color="#EDF7FD"/>
</linearGradient>
<linearGradient id="paint1_linear_843_14" x1="15.126" y1="9.25833" x2="15.126" y2="17.3533" gradientUnits="userSpaceOnUse">
<stop stop-color="#EDF7FD"/>
<stop offset="0.503088" stop-color="white"/>
<stop offset="1" stop-color="#EDF7FD"/>
</linearGradient>
<linearGradient id="paint2_linear_843_14" x1="13.6462" y1="15.1552" x2="13.6462" y2="21.8751" gradientUnits="userSpaceOnUse">
<stop stop-color="#EDF7FD"/>
<stop offset="0.503088" stop-color="white"/>
<stop offset="1" stop-color="#EDF7FD"/>
</linearGradient>
<clipPath id="clip0_843_14">
<rect width="21" height="19" fill="white" transform="translate(2 3)"/>
</clipPath>
</defs>
</svg>





  
);

const PromoSlider = () => {
  const navigate = useNavigate();
  const dragged = useRef(false);
  const startX = useRef(0);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchThreshold: 12,
    pauseOnHover: true,
    cssEase: "ease-in-out",
  };

  // Record where the press began and reset the drag flag.
  const onPressStart = (clientX) => {
    startX.current = clientX;
    dragged.current = false;
  };

  // Flag a drag once the pointer/finger moves past a small threshold. 
  const onPressMove = (clientX) => {
    if (Math.abs(clientX - startX.current) > 6) dragged.current = true;
  };

  // Navigate only when it was a genuine click/tap, not a swipe.
  const navigateIfClick = (path) => () => {
    if (!dragged.current) navigate(path);
  };

  // Shared handlers so the whole slide reacts to mouse, touch and keyboard.
  const slideHandlers = (path) => ({
    onMouseDown: (e) => onPressStart(e.clientX),
    onMouseMove: (e) => onPressMove(e.clientX),
    onTouchStart: (e) => onPressStart(e.touches[0].clientX),
    onTouchMove: (e) => onPressMove(e.touches[0].clientX),
    onClick: navigateIfClick(path),
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        navigate(path);
      }
    },
    role: "button",
    tabIndex: 0,
  });

  return (
    <div className={styles.promo}>
      <Slider {...settings}>
        {/* Slide 1 — Award bug */}
        <div>
          <div
            className={`${styles.slide} ${styles.awardSlide}`}
            aria-label="View the Deseyne MedTech Breakthrough Award 2026"
            {...slideHandlers("/deseyne-medtech-breakthrough-award-2026")}
          >
           
            <div className={styles.slideBody}>
              <div className={styles.slideHead}>
                <span className={styles.iconBadge}>
                  <AwardIcon />
                </span>
                <h5 className={styles.slideTitle}>AWARD RECOGNITION</h5>
              </div>
              <img src="/Images/Award_bug.webp" alt="Deseyne® MedTech Breakthrough Award 2026" />
              {/* <p className={styles.assessText}>Best New Technology Solution in Ophthalmology</p> */}
              <span className={styles.assessCta}>Learn More →</span>
            </div>
          </div>
        </div>

        {/* Slide 2 — Academy 2026 */}
        {/* <div>
          <div
            className={`${styles.slide} ${styles.assessSlide} ${styles.assessSlideTwo}`}
            aria-label="Start practice assessment 2"
            {...slideHandlers("/academy-2026-anaheim")}
          >
            
            <div className={styles.slideBody}>
              <div className={styles.slideHead}>
                <span className={styles.iconBadge}>
                  <DropIcon />
                </span>
                <h5 className={styles.assessEyebrow}>ACADEMY 2026 ANAHEIM</h5>
              </div>
              <h3 className={styles.assessTitle}>
                Meet Bruno Vision Care at Academy 2026
              </h3>
              <p className={styles.assessdesc}>Visit our booth to explore Deseyne®, connect with our team, and book a fitting discussion.</p>
              <span className={styles.assessCta}>Explore Event →</span>
            </div>
          </div>
        </div> */}

        {/* Slide 3 — Landmark clinical study publication */}
        <div>
          <div
            className={`${styles.slide} ${styles.assessSlide}`}
            aria-label="Read the landmark clinical study"
            {...slideHandlers("/deseyne-clinical-study")}
          >

            <div className={styles.slideBody}>
              <div className={styles.slideHead}>
                <span className={styles.iconBadge}>
                  <ClinicalGraphic className={styles.badgeGraphic} />
                </span>
                <h5 className={styles.slideTitle}>NEW CLINICAL PUBLICATION</h5>
              </div>
              <h3 className={styles.assessTitle}>Landmark Clinical Study Published</h3>
              <p className={styles.assessdesc}>Read the peer-reviewed publication validating Deseyne® Extended Depth of Focus technology for presbyopia.</p>
              <span className={styles.assessCta}>Read the Full Study →</span>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default PromoSlider;
